import { z } from 'zod';
import { ContractSchema, ContractSlotSchema } from '../data/contracts.js';
/**
 * Daily and weekly contracts (ADR 0051). The client asks for its contracts
 * and cashes one by its slot, from anywhere; the server draws them, reads
 * their progress in the career and pays in one transaction.
 */
export const ContractsRequestSchema = z.object({}).strict();
export const ContractClaimMessageSchema = z.object({ contractId: ContractSlotSchema }).strict();
export const ContractViewSchema = ContractSchema.extend({
    progress: z.number().int().min(0),
    claimed: z.boolean(),
});
/** Every contract of the day and the week, to their owner alone, and when they renew. */
export const ContractsEventSchema = z.object({
    daily: z.array(ContractViewSchema),
    weekly: ContractViewSchema,
    dayEndsInMs: z.number().int().min(0),
    weekEndsInMs: z.number().int().min(0),
    /** Zone bosses whose loot of the day this character has yet to take (ADR 0090). */
    bossBonus: z.array(z.string().min(1)),
    /** The account's streak: days counted, and whether today is one of them. */
    streak: z.object({ days: z.number().int().min(0), today: z.boolean() }),
});
export const ContractClaimedSchema = z.object({
    contractId: ContractSlotSchema,
    gold: z.number().int().min(0),
    items: ContractSchema.shape.reward.shape.items,
});
export const CONTRACT_REFUSALS = [
    'invalid',
    'not-done',
    'claimed',
    'bag-full',
    'busy',
    /** The contract was paid, but the streak's reward did not fit: the day is counted at the next one. */
    'streak-bag-full',
];
export const ContractRejectedSchema = z.object({ reason: z.enum(CONTRACT_REFUSALS) });
/** To the character alone: the first kill of this boss today, its day's loot on the ground. */
export const BossBonusEventSchema = z.object({ bossId: z.string().min(1) });
/** A day counted in the streak, and what it paid to this character. */
export const StreakRewardEventSchema = z.object({
    days: z.number().int().min(1),
    gold: z.number().int().min(0),
    items: ContractSchema.shape.reward.shape.items,
});
//# sourceMappingURL=contracts.js.map